// @flow

// Libs
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

// Operator
import ordersOperator from 'hfty-operator-orders'

// Selectors
import { supplies$ } from 'hfty-supplies/src'
import { currentUser$ } from 'hfty-users/src'

// Actions & Selectors
import {
  createOrder,
  updateUserBillingInfo,
  operations$,
  operation$,
  order$,
} from 'hfty-orders'

// Components
import Layout from '../components/Layout'

function mapStateToProps (state: Object): Props {
  return {
    operations: operations$(state),
    operation: operation$(state),
    supplies: supplies$(state),
    currentUser: currentUser$(state),
    order: order$(state),
  }
}

type MapDispatchToProps = {
  actions: {
    createOrder: Function,
    updateUserBillingInfo: Function,
    onCancelOperations: Function,
    onSubmitOperations: Function,
    fetchHeftyCrops: Function,
  }
}

function mapDispatchToProps (dispatch: Dispatch<*>): MapDispatchToProps {
  return {
    actions: bindActionCreators({
      createOrder,
      updateUserBillingInfo,
      onChangeOperation: ordersOperator.actionCreators.updateOperation,
      onCancelOperations: ordersOperator.actionCreators.cancelOperations,
      onSubmitOperations: ordersOperator.actionCreators.submitOperations,
    }, dispatch),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Layout)
